export default __webpack_public_path__ + "static/media/icon_youtube.d2b9dfeb.svg";